module.exports = __webpack_public_path__ + "img/29_20.bb6748cf.png";